import * as React from "react";
import { Search } from "lucide-react";
import { Input } from "@/shared/components";
import { cn } from "@/shared/lib/utils";

interface LabelSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  autoFocus?: boolean;
}

export const LabelSearchInput = React.forwardRef<HTMLInputElement, LabelSearchInputProps>(
  ({ value, onChange, placeholder = "Search labels…", className, autoFocus }, ref) => (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        ref={ref}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className={cn("pl-9 h-9", className)}
        aria-label={placeholder}
      />
    </div>
  )
);
LabelSearchInput.displayName = "LabelSearchInput";
